module.exports = __webpack_public_path__ + "assets/img/index-leftmenu-bg@3x.6e723040.png";